import React, { useEffect, useState } from "react";
import { Line, Bar } from "react-chartjs-2";
import "./mainDashboard.css";
import { Progress } from "antd";
import { DatePicker } from "antd";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { useTheme } from "../../utils/ThemeContext";
import FETCH from "../../utils/fetch";
export const GoalProgress = ({ getAllGoals }) => {
  const { theme } = useTheme();

  const { MonthPicker } = DatePicker;

  const [loading, setLoading] = useState(false);
  const [goalsData, setGoalsData] = useState([]);

  const getGoalsList = async () => {
    try {
      setLoading(true);
      let response = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Goals&page=1&limit=100`,
        body: {},
      });
      if (response && response.records) {
        setGoalsData(response.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getGoalsList();
  }, []);

  function getMonthsDifference(date1, date2) {
    const year1 = date1.getFullYear();
    const year2 = date2.getFullYear();
    const month1 = date1.getMonth();
    const month2 = date2.getMonth();

    return (year2 - year1) * 12 + (month2 - month1);
  }
  const calculateGoalNeed = (amountNeed, date) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;

    const GoalInflationRate = 10;
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);

    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    return parseFloat(result).toFixed(2);
  };
  const handleMonthChange = (date, dateString) => {
    if (date) {
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      console.log("Start Date of the Month:", startDate);
      console.log("End Date of the Month:", endDate);
      getAllGoals(startDate, endDate);
    }
  };

  return (
    <React.Fragment>
      {" "}
      <div
        className="SavingMainCard1"
        style={{
          position: "relative",
          width: "100%",
          padding: "0px",
          borderRadius: "0px",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <div className="filterWithName">
          <h1
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}
            className="SavingCardheading"
          >
            Goal Progress
          </h1>
          {/* <div className="compareSelectContainer">
            <span
              style={{
                color: theme === "light" ? "#232323" : "white",
              }}
              className="mainfilterHeading"
            >
              Apply Filter:{" "}
            </span>
            <MonthPicker
              className="monthPickerStyle1"
              style={{
                width: "180px",
                border: "1px solid #2a3da3",
                height: "36px",
                // top: "40px",
              }}
              onChange={handleMonthChange}
              format="MMMM YYYY"
              placeholder="Select month"
            />
          </div> */}
        </div>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            flexDirection: "column",
            maxHeight: "320px",
            overflowY: "auto",
            gap: "1rem",
          }}
        >
          {goalsData && goalsData.length > 0 ? (
            goalsData.map((item, index) => {
              let need = item["Dollar Amount Needed"]
                ? calculateGoalNeed(
                    item["Dollar Amount Needed"],
                    item["Goal Date"] ? item["Goal Date"] : new Date()
                  )
                : 0;
              let have = (
                (item.assignAssets && Array.isArray(item.assignAssets)
                  ? item.assignAssets.reduce(
                      (acc, curr) =>
                        acc + parseFloat(curr.amountUseForGoal || 0),
                      0
                    )
                  : 0) +
                (item["Amount Received"] &&
                Array.isArray(item["Amount Received"])
                  ? item["Amount Received"].reduce(
                      (acc, curr) => acc + parseFloat(curr || 0),
                      0
                    )
                  : 0)
              )
                .toFixed(2)
                .toString();
              let completionPercentage = (
                (parseFloat(have) / parseFloat(need)) *
                100
              ).toFixed(2);
              return (
                <div
                  key={index}
                  className=""
                  style={{ display: "flex", gap: "1rem", marginTop: "8px" }}
                >
                  <div style={{ width: "100%" }}>
                    <div className="budgetDropDown">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="budgetCardTitle"
                      >
                        {item["Description of Goal"] &&
                          item["Description of Goal"]}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="budgetCardTitle"
                      >
                        Have: $
                        {parseFloat(have)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                      </span>
                    </div>
                    <Progress
                      className="goalProgress"
                      type="line"
                      //   height="40px"
                      strokeColor={
                        item && item.assigned_amount
                          ? +item.assigned_amount > +item.goal_need
                            ? "#2A3DA3"
                            : "#34C759"
                          : "#34C759"
                      }
                      trailColor="#6A6C74"
                      percent={
                        completionPercentage >= 100
                          ? "100.00"
                          : completionPercentage
                      }
                      // successPercent={item && +item.assigned_amount
                      //   ? (+item.assigned_amount / item.goal_need) * 100
                      //   : 0}
                      showInfo={false}
                      //   format={(percent) => `${percent.toFixed(2)}%`}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "1rem",
                      }}
                    >
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="budgetCardTitle"
                      >
                        Need: $
                        {parseFloat(need)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                        }}
                        className="budgetCardTitle"
                      >
                        Completion: {" "}
                        {completionPercentage >= 100
                          ? "100.00"
                          : isNaN(completionPercentage) ? "0.00" : completionPercentage}{" "}
                        %
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <span
              style={{
                color: theme === "light" ? "#232323" : "white",
              }}
              className="noDataToShow"
            >
              No Goal To Show for this Month
            </span>
          )}
        </div>
        <NewLoader isLoading={loading} />
      </div>
    </React.Fragment>
  );
};
